export default (controller, action) => `/api/${controller}/${action}`;